import { render, staticRenderFns } from "./right_1.vue?vue&type=template&id=72ebbd31&scoped=true&"
import script from "./right_1.vue?vue&type=script&lang=js&"
export * from "./right_1.vue?vue&type=script&lang=js&"
import style0 from "./right_1.vue?vue&type=style&index=0&id=72ebbd31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebbd31",
  null
  
)

export default component.exports